import { jsx as t, jsxs as b } from "@emotion/react/jsx-runtime";
import { useState as y } from "react";
import { ProductIconV2 as g } from "@partoohub/iconography";
import { useLocation as k } from "react-router";
import { NavigationLink as S, NavigationLinkContent as x, NavigationLinkTitle as L, DotContainer as N, RedDot as w, StyledTextNotification as C } from "./MenuItem.styled.js";
import { useSidebarContext as u } from "../../SidebarContext.js";
import { SidebarIconContainer as H, OverrideStack as P, StyledText as T } from "../BaseMenu/BaseMenu.styled.js";
const V = ({
  menuItem: o
}) => {
  const {
    extended: i,
    showMoreMenu: r
  } = u(), {
    pathname: c
  } = k(), [s, n] = y(!1), e = o?.notification ?? 0, d = !!o?.notification && o.notification > 0, l = e > 99 ? "99+" : e, h = (M) => c.startsWith(M), a = typeof o.to == "string" && h(o.to), v = s || a, p = () => {
    n(!0);
  }, f = () => {
    n(!1);
  };
  return /* @__PURE__ */ t(S, { "data-track": o.dataTrackId, "data-partoorobot": o.dataPartooRobot, to: o.to, replace: o?.replace, isActive: a, target: o.target ? "_blank" : void 0, children: /* @__PURE__ */ t(x, { onMouseEnter: p, onMouseLeave: f, children: /* @__PURE__ */ t(L, { children: /* @__PURE__ */ t(H, { children: /* @__PURE__ */ b(P, { gap: "6px", alignItems: "center", direction: "row", children: [
    d && // DotContainer is necessary to position the RedDot correctly
    /* @__PURE__ */ t(N, { extended: i, showMore: r, children: /* @__PURE__ */ t(w, { extended: i, showMore: r, children: i && /* @__PURE__ */ t(C, { as: "span", variant: "bodySSemibold", className: "color--white", extended: i, children: l }) }) }),
    /* @__PURE__ */ t(g, { name: o.icon, color: "secondary", activeColor: "primary", active: a, isHovered: v }),
    /* @__PURE__ */ t(T, { variant: a ? "bodyMSemibold" : "bodyMRegular", as: "span", color: a ? "primary" : "secondary", extended: i, children: o.name })
  ] }) }) }) }) });
};
export {
  V as MenuItem
};
